import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ConfigurationKeyName } from '../enums/configuration-key-name';
import { FeatureName } from '../enums/feature-name';

@Injectable({ providedIn: 'root' })
export class AppConfigurationService {

  private featureFlags: { [key in FeatureName]?: boolean } = {};
  private configurationKeys: { [key in ConfigurationKeyName]?: boolean } = {};
  private configurationNames: { [key in ConfigurationKeyName]?: string } = {};
  private configurationArrayValue: { [key in ConfigurationKeyName]?: string[] } = {};

  constructor(private http: HttpClient) { }

  getFeatureFlag(featureName: FeatureName) {
    if (this.featureFlags[featureName] === undefined) {
      return this.http.get<boolean>(`${environment.configurationApiUrl}/api/features/${featureName}`)
        .pipe(
          tap(value => this.featureFlags[featureName] = value),
          catchError(() => of(false))
        );
    } else {
      return of(this.featureFlags[featureName]);
    }
  }

  getConfiguration(KeyName: ConfigurationKeyName) {
    if (this.configurationKeys[KeyName] === undefined) {
      return this.http.get<any>(`${environment.configurationApiUrl}/api/configurations/${KeyName}`)
        .pipe(
          tap(value => this.configurationKeys[KeyName] = value),
          catchError(() => of(false))
        );
    } else {
      return of(this.configurationKeys[KeyName]);
    }
  }

  getStringConfiguration(KeyName: ConfigurationKeyName) {
    if (this.configurationNames[KeyName] === undefined) {
      return this.http.get<string>(`${environment.configurationApiUrl}/api/configurations/${KeyName}`)
        .pipe(
          tap(value => this.configurationNames[KeyName] = value),
          catchError(() => of(''))
        );
    } else {
      return of(this.configurationNames[KeyName]);
    }
  }

    getArrayConfigurationValue(configurationName: ConfigurationKeyName) {
    if(this.configurationArrayValue[configurationName] === undefined) {
      return this.http.get<string[]>(`${environment.configurationApiUrl}/api/configurations/${configurationName}`)
        .pipe(
          tap(value => this.configurationArrayValue[configurationName] = value));
    } else {
      return of(this.configurationArrayValue[configurationName]);
    }
  }
}
